import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  checkPollingData,
  updateProcessedBulkData,
  updateProcessedBulkStatus,
} from "../../actions/bulkProcessAction";
import {
  POLLING_STATUS_IMAGES,
  BATCH_STATUS_POLLING,
} from "../../constants/bulkProcessConstant";
import { makeRequestAuth } from "../../utils/globals";
import BulkProcessService from "../../services/bulkProcessService";
import { NotificationManager } from "react-notifications";
import {
  Icon,
  Popover as InitialPopover,
  Badge,
  Typography,
} from "@plum-xoxo/admin-dsm";
import theme from "../../theme";
import styled from "styled-components";

let timer;

const ProgressBar = styled.div`
  max-width: 150px;
  width: 100%;
  height: 4px;
  background-color: ${theme.palette.light.c300};
  position: relative;
  border-radius: 4px;
  &:before {
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
    width: ${(props) => props.width}%;
    height: 4px;
    content: "";
    background-color: ${theme.palette.primary.c02};
  }
`;

const Popover = styled(InitialPopover).attrs()`
  .eui-option-inner {
    padding: 16px;
    border-radius: 0px;
  }
`;

const Chip = styled(Badge).attrs()`
  padding: 4px 8px;
  .eui-tag-label {
    text-transform: capitalize;
  }
`;

class BulkUploadProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showComponent: false,
      onMouseHighlightIndex: -1,
    };
  }

  componentDidMount() {
    timer = setInterval(() => this.polling(), 5000);
  }

  componentWillUnmount() {
    clearInterval(timer);
  }

  polling = () => {
    const { bulkProcessData } = this.props;
    // const bulkProcessData = this.props && [...this.props.bulkProcessData]
    if (bulkProcessData.length > 0) {
      this.props.checkPollingData(bulkProcessData);
    }
  };

  toggleBulkProgress = () => {
    this.setState({
      showComponent: !this.state.showComponent,
    });
  };

  cancelBatch = (index) => {
    const { bulkProcessData } = this.props;
    let data = {
      batch_id: bulkProcessData[index].batch_id,
      reward_type: bulkProcessData[index].reward_type,
    };
    BulkProcessService.cancelBatch(data).then((response) => {
      if (
        response &&
        response.bulkCancelBatch &&
        !response.bulkCancelBatch.error
      ) {
        NotificationManager.success("Batch Cancellation Success.");
      } else {
        NotificationManager.error("Could Not Cancel batch");
      }
    });
  };

  handleUrl = (fileUrl) => {
    const downloadData = {
      query: "stores.mutation.fileDownload",
      tag: "stores",
      variables: {
        add_data: fileUrl,
      },
    };
    makeRequestAuth(
      downloadData,
      function (resp) {
        if (
          resp &&
          resp.data &&
          resp.data.fileDownload &&
          resp.data.fileDownload.output
        ) {
          let response = JSON.parse(resp.data.fileDownload.output);
          let url = "data:" + response.type + ";base64," + response.data;
          var link = document.createElement("a");
          link.download = response && response.filename;
          link.href = url;
          link.click();
        }
      }.bind(this)
    );
  };

  removeFileFromQueue = (index) => {
    let bulkProcessData = [];
    let bulkProcessStatus = [];
    bulkProcessData = [...this.props.bulkProcessData];
    bulkProcessStatus = [...this.props.bulkProcessStatus];
    bulkProcessData.splice(index, 1);
    bulkProcessStatus.splice(index, 1);
    this.props.updateProcessedBulkData(bulkProcessData);
    this.props.updateProcessedBulkStatus(bulkProcessStatus);
  };

  renderFileHeader = (index) => {
    const { bulkProcessData, bulkProcessStatus } = this.props;

    const { onMouseHighlightIndex } = this.state;

    let status = [BATCH_STATUS_POLLING.PROCESSING];
    const getImageIndex = (index) => {
      const processedCount =
        bulkProcessStatus[index].scheduledCount +
        bulkProcessStatus[index].total_success;
      const unProcessedCount =
        bulkProcessStatus[index].total_rows - processedCount;
      if (
        bulkProcessStatus[index].status == BATCH_STATUS_POLLING.COMPLETE &&
        unProcessedCount > 0
      ) {
        return POLLING_STATUS_IMAGES.COMPLETE_2;
      } else if (
        bulkProcessStatus[index].status ==
          BATCH_STATUS_POLLING.VALIDATION_SUCCESS &&
        bulkProcessStatus[index].is_scheduler
      ) {
        return POLLING_STATUS_IMAGES.COMPLETE;
      } else {
        return POLLING_STATUS_IMAGES[
          bulkProcessStatus[index] && bulkProcessStatus[index].status
        ];
      }
    };
    return (
      <>
        <Row>
          <Col xs="1">
            <img src={getImageIndex(index)} className="" />
          </Col>
          <Col xs="10">
            <p className="medium mb-1">
              {/* <a href="#" onClick={() => {this.handleUrl(bulkProcessStatus[index].final_file_path)}} >
								{bulkProcessData[index] && bulkProcessData[index].fileName}
							</a> */}
              {bulkProcessData[index] && bulkProcessData[index].fileName}
            </p>
          </Col>
          {!status.includes(bulkProcessStatus[index].status) ? (
            <Col xs="1">
              <span className="float-right">
                <img
                  className="bulk-clear-response-alert"
                  onClick={() => {
                    this.removeFileFromQueue(index);
                  }}
                  onMouseOver={() => {
                    this.setState({ onMouseHighlightIndex: index });
                  }}
                  onMouseLeave={() => {
                    this.setState({ onMouseHighlightIndex: -1 });
                  }}
                  src={
                    onMouseHighlightIndex == index
                      ? "/admin/img/icons/bulk-cancel-fil.svg"
                      : "/admin/img/icons/bulk-cancel.svg"
                  }
                />
              </span>
            </Col>
          ) : null}
        </Row>
      </>
    );
  };

  renderProcessingData = () => {
    const { bulkProcessData, bulkProcessStatus, client_id } = this.props;
    if (bulkProcessStatus && bulkProcessStatus.length > 0) {
      return bulkProcessStatus.map((ele, i) => {
        if (bulkProcessData[i].client_id !== client_id) {
          return "";
        }
        const processedCount = ele.scheduledCount + ele.total_success;
        const unProcessedCount = ele.total_rows - processedCount;
        let status =
          processedCount === 0 && ele?.status === BATCH_STATUS_POLLING.COMPLETE
            ? "Failure"
            : ele?.status?.toLowerCase() || "";
        const rewardType = [
          "Reward Points",
          "Reward Codes ",
          "Reward Link",
          "Gift Cards",
        ];
        if (bulkProcessData[i]?.fileName) {
          if (bulkProcessData[i]?.fileName?.length > 28) {
            bulkProcessData[i].fileName =
              bulkProcessData[i]?.fileName.slice(0, 28) + "...";
          }
        }
        switch (status.toUpperCase()) {
          case BATCH_STATUS_POLLING.COMPLETE:
            return (
              <Popover.Options>
                <div>
                  <div className="d-flex align-items-center justify-content-between">
                    <Typography.LabelText color="dark" shade="c300">
                      {bulkProcessData[i]?.fileName}
                    </Typography.LabelText>
                    <div>
                      <Chip
                        label={status}
                        bg={theme.palette.green.c000}
                        color={theme.palette.green.c300}
                        className="px-8"
                      />
                    </div>
                  </div>
                  <Typography.BodySmall
                    component="div"
                    className="mt-4"
                    color="dark"
                    shade="c200"
                  >
                    {processedCount} records for{" "}
                    {rewardType[bulkProcessData[i].reward_type - 1]} processed
                    <br />
                    {unProcessedCount > 0 ? (
                      <>
                        <div className="d-flex align-items-center justify-content-start mt-12">
                          <div>
                            <a
                              href="#"
                              style={{
                                fontSize: "14px",
                                color: theme.palette.primary.c02,
                                lineHeight: "20px",
                                fontWeight: "500",
                              }}
                              className="mr-4"
                              onClick={() => {
                                this.handleUrl(ele.final_file_path);
                              }}
                            >
                              Download{" "}
                            </a>
                          </div>
                          <div>the unprocessed records and upload again</div>
                        </div>
                      </>
                    ) : null}
                  </Typography.BodySmall>
                </div>
              </Popover.Options>
            );

          case BATCH_STATUS_POLLING.FAILURE:
            return (
              <Popover.Options className="list-group-item-alert">
                <div className="d-flex justify-content-between">
                  <div>
                    <Typography.LabelText color="dark" shade="c300">
                      {bulkProcessData[i]?.fileName}
                    </Typography.LabelText>
                    <Typography.BodySmall
                      component="div"
                      className="mt-4"
                      color="dark"
                      shade="c200"
                    >
                      {ele.total_rows - processedCount} records failed.
                    </Typography.BodySmall>
                  </div>
                  <div>
                    <Badge
                      label={status}
                      bg={theme.palette.orange.c000}
                      color={theme.palette.orange.c200}
                      className="px-8"
                    />
                  </div>
                </div>
                <Typography.BodySmall
                  component="div"
                  className="mt-4"
                  color="dark"
                  shade="c200"
                >
                  <div className="d-flex align-items-center justify-content-start mt-12">
                    <div>
                      <a
                        href="#"
                        style={{
                          fontSize: "14px",
                          color: theme.palette.primary.c02,
                          lineHeight: "20px",
                          fontWeight: "500",
                        }}
                        className="mr-4"
                        onClick={() => {
                          this.handleUrl(ele.final_file_path);
                        }}
                      >
                        Download{" "}
                      </a>
                    </div>
                    <div>the unprocessed records and upload again</div>
                  </div>
                </Typography.BodySmall>
              </Popover.Options>
            );

          case BATCH_STATUS_POLLING.CANCELLED:
            return (
              <Popover.Options className="list-group-item-alert">
                <div className="d-flex justify-content-between">
                  <div>
                    <Typography.LabelText color="dark" shade="c300">
                      {bulkProcessData[i]?.fileName}
                    </Typography.LabelText>
                    <Typography.BodySmall
                      component="div"
                      className="mt-4"
                      color="dark"
                      shade="c200"
                    >
                      Uploading Cancelled
                    </Typography.BodySmall>
                  </div>
                  <div>
                    <Badge
                      label={status}
                      bg={theme.palette.green.c000}
                      color={theme.palette.green.c300}
                      className="px-8"
                    />
                  </div>
                </div>
              </Popover.Options>
            );
          case BATCH_STATUS_POLLING.PROCESSING:
            return (
              <Popover.Options className="list-group-item-alert">
                <div className="d-flex justify-content-between">
                  <div>
                    <Typography.LabelText color="dark" shade="c300">
                      {bulkProcessData[i]?.fileName}
                    </Typography.LabelText>
                    <Typography.BodySmall
                      component="div"
                      className="mt-4"
                      color="dark"
                      shade="c200"
                    >
                      {processedCount} out of {ele.total_rows} records processed
                    </Typography.BodySmall>
                  </div>
                  <div>
                    <Badge
                      label={"In Progress"}
                      bg={theme.palette.light.c300}
                      color={theme.palette.dark.c200}
                      className="px-8"
                    />
                  </div>
                </div>
              </Popover.Options>
            );
          case BATCH_STATUS_POLLING.PARTIALLY_PROCESSED:
            return (
              <Popover.Options className="list-group-item-alert">
                <div className="d-flex justify-content-between">
                  <div>
                    <Typography.LabelText color="dark" shade="c300">
                      {bulkProcessData[i]?.fileName}
                    </Typography.LabelText>
                  </div>
                  <div>
                    <Badge
                      label={"Partially Processed"}
                      bg={theme.palette.light.c300}
                      color={theme.palette.dark.c200}
                      className="px-8"
                    />
                  </div>
                </div>
                <Typography.BodySmall
                  component="div"
                  className="mt-4"
                  color="dark"
                  shade="c200"
                >
                  {ele.total_rows - processedCount} records failed.
                  <br />
                  {unProcessedCount > 0 ? (
                    <>
                      <div className="d-flex align-items-center justify-content-start mt-12">
                        <div>
                          <a
                            href="#"
                            style={{
                              fontSize: "14px",
                              color: theme.palette.primary.c02,
                              lineHeight: "20px",
                              fontWeight: "500",
                            }}
                            className="mr-4"
                            onClick={() => {
                              this.handleUrl(ele.final_file_path);
                            }}
                          >
                            Download{" "}
                          </a>
                        </div>
                        <div>the unprocessed records and upload again</div>
                      </div>
                    </>
                  ) : null}
                </Typography.BodySmall>
              </Popover.Options>
            );
          case BATCH_STATUS_POLLING.VALIDATION_SUCCESS:
            return (
              <Popover.Options className="list-group-item-alert">
                <div className="d-flex justify-content-between">
                  <div>
                    <Typography.LabelText color="dark" shade="c300">
                      {bulkProcessData[i]?.fileName}
                    </Typography.LabelText>
                    <Typography.BodySmall
                      component="div"
                      className="mt-4"
                      color="dark"
                      shade="c200"
                    >
                      {ele.is_scheduler
                        ? "Bulk Upload Scheduled. You can see the reports."
                        : "The processing has started. It could take upto 2-3 minutes for the status to reflect."}
                    </Typography.BodySmall>
                  </div>
                  <div>
                    <Badge
                      label={status}
                      bg={theme.palette.green.c000}
                      color={theme.palette.green.c300}
                      className="px-8"
                    />
                  </div>
                </div>
              </Popover.Options>
            );
          default:
          // return(
          // 	<ListGroupItem className="list-group-item-alert">
          // 		<Row>
          // 			<Col xs="11 offset-1">
          // 				{/* <p className="info">
          // 					<span className="">
          // 						Processing File. Please Wait.
          // 					</span>
          // 				</p> */}
          // 			</Col>
          // 		</Row>
          // 	</ListGroupItem>
          // )
        }
      });
    } else {
      return null;
    }
  };

  render() {
    const { showComponent } = this.state;
    const { bulkProcessData, client_id, bulkProcessStatus = [] } = this.props;
    let statusProcessing = [
      BATCH_STATUS_POLLING.PROCESSING,
      BATCH_STATUS_POLLING.VALIDATION_SUCCESS,
    ];
    const activeProcess = bulkProcessStatus?.filter((ele, index) => {
      //remove this after abhiram change && bulkProcessData[index].reward_type !== 3
      let retValue =
        ele.is_scheduler == 0 && statusProcessing.includes(ele.status);
      return (
        retValue && bulkProcessData[index]?.client_id === this.props.client_id
      );
    });
    // let activeProcess = [
    //   {
    //     total_rows: 2,
    //     total_validation_error: 0,
    //     status: "COMPLETE",
    //     final_file_path: null,
    //     scheduledAmount: 0,
    //     currentAmount: 0,
    //     insufficient_fund: 0,
    //     insufficient_threshold: 0,
    //     is_scheduler: 0,
    //     scheduledCount: 0,
    //     currentCount: 0,
    //     total_processed: 2,
    //     total_success: 2,
    //   },
    // ];
    const getActiveCount = activeProcess?.length;
    let total_rows = 1;
    let total_processed = 1;
    activeProcess?.map((process) => {
      total_rows += process.total_rows;
      total_processed += process.total_processed;
    });

    const checkClientLength = bulkProcessData.some(function (product) {
      return product.client_id === client_id;
    });

    let failedRewards = () => {
      if (bulkProcessStatus?.length) {
        let clientFailedRewards = bulkProcessStatus.filter((ele, i) => {
          if (bulkProcessData[i].client_id !== client_id) {
            return false;
          }
          return true;
        });
        let lastUpload = clientFailedRewards[clientFailedRewards.length - 1];
        const processedCount =
          (lastUpload?.scheduledCount || 0) + (lastUpload?.total_success || 0);
        if (
          (processedCount == 0 &&
            lastUpload?.status === BATCH_STATUS_POLLING.COMPLETE) ||
          lastUpload?.status === BATCH_STATUS_POLLING.PARTIALLY_PROCESSED
        )
          return true;
        return false;
      }
      return false;
    };

    return checkClientLength ? (
      <div>
        <Popover
          offset={[-15, 0]}
          content={
            <>
              <div className="d-flex align-items-center justify-content-between m-16">
                <Typography.H3>
                  Bulk rewards{" "}
                  {parseInt((total_processed / total_rows) * 100) === 100
                    ? "processed"
                    : "processing"}
                </Typography.H3>
              </div>
              <hr className="my-0" />
              <div
                style={{
                  maxHeight: "240px",
                  overflow: "scroll",
                }}
                className="pb-20"
              >
                {this.renderProcessingData()}
              </div>
            </>
          }
          placement="bottom"
          trigger="hover"
          width={440}
        >
          <>
            <div
              style={{
                backgroundColor: theme.palette.light.c100,
                borderRadius: "0px",
                border: `1px solid ${theme.palette.light.c300}`,
                fontSize: "12px",
              }}
              className="p-8 d-flex align-items-center mr-24"
            >
              <Typography.BodySmall color="dark" shade="c200" component="div">
                Bulk rewards{" "}
                {parseInt((total_processed / total_rows) * 100) === 100
                  ? "processed"
                  : "processing"}
              </Typography.BodySmall>{" "}
              <Typography.BodySmall
                component="div"
                color="dark"
                shade="c200"
                className="ml-4"
              >
                ({parseFloat((total_processed / total_rows) * 100).toFixed(2)}%)
              </Typography.BodySmall>
              {failedRewards() && (
                <div className="d-flex align-items-center ml-8">
                  <Icon
                    iconName="PlumInfoFill"
                    color="orange"
                    shade="c200"
                    size={20}
                  />
                </div>
              )}
            </div>
          </>
        </Popover>
        {/* <ButtonDropdown
          isOpen={showComponent}
          toggle={this.toggleBulkProgress}
          className=" bulkProgress"
        >
          <DropdownToggle className=" pr-0 pl-0 ">
            {getActiveCount > 0 ? (
              <>
                <Tooltip
                  placement="bottom"
                  tooltip={`${getActiveCount} ${
                    getActiveCount > 1 ? " bulk files are " : " bulk file is "
                  }  under process`}
                >
                  <img
                    src="https://res.cloudinary.com/dyyjph6kx/image/upload/v1620919699/store/Logo/upload-animation.gif"
                    className="bulk-image-progress-nav"
                  />
                </Tooltip>
              </>
            ) : (
              <IconProcessignCompleted />
            )}
          </DropdownToggle>
          <DropdownMenu
            color="link"
            left
            className="dropMenu"
            style={{ top: "60px", right: "20px" }}
          >
            <div
              className="progress-list"
              style={{ maxHeight: "560px", width: "400px", overflow: "auto" }}
            >
              <ListGroup className="list-group-align">
                <ListGroupItem className="bulk-progress-header">
                  <h2 className="bulk-header-name medium-normal">
                    Bulk upload progress{" "}
                  </h2>
                  <p className="small">
                    Processing of bulk uploaded files take time. Once processed,
                    wallet and reports will be updated accordingly. You can
                    cancel processing from Reports.
                  </p>
                </ListGroupItem>
                {this.renderProcessingData()}
              </ListGroup>
            </div>
          </DropdownMenu>
        </ButtonDropdown> */}
      </div>
    ) : null;
  }
}

const mapStateToProps = (state) => {
  const { bulkProcessReducer: { bulkProcessData, bulkProcessStatus } = {} } =
    state;
  return {
    bulkProcessData,
    bulkProcessStatus,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkPollingData: (params, bulkProcessData, index) =>
        checkPollingData(params, bulkProcessData, index),
      updateProcessedBulkData: (bulkProcessData) =>
        updateProcessedBulkData(bulkProcessData),
      updateProcessedBulkStatus: (bulkProcessStatus) =>
        updateProcessedBulkStatus(bulkProcessStatus),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BulkUploadProgress);
